// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { TaskCommand } from "./TaskCommand.gen";

export interface IStreamVideoCommandParams {
	command: TaskCommand;

	fps: number | undefined;

	tcpStreamIp: string | undefined;

	tcpStreamPort: number | undefined;

	$type?: string | undefined;
}
export class StreamVideoCommandParams {
	constructor(data?: IStreamVideoCommandParams) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	command: TaskCommand = 0;

	fps: number | undefined;

	tcpStreamIp: string | undefined;

	tcpStreamPort: number | undefined;

	static $type: string = "CoreApi.Models.DeviceCommands.StreamVideoCommandParams, ";
	$type?: string | undefined = StreamVideoCommandParams.$type;
}

